import { useSelector, shallowEqual, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import * as action from '../actions/profiles';
import { RootState } from "../reducers";
import { ProfilesState } from '../../components/Profiles/types';

export const useProfilesState = () => {
  const { user, profiles } : ProfilesState = useSelector((state: RootState) => ({
    profiles: state.profiles,
    user: state.user
  }), shallowEqual);
  return { user, profiles };
};

export const useProfilesDispatch = () => {
  const dispatch = useDispatch();
  return { ...bindActionCreators( { ...action }, dispatch) };
};